/**
 * 封装用于页面直接跳转的函数
 * path:路径
 * query:参数
 */
function navigationTo(path, query, isSelf) {
    let newpage = this.$router.resolve({
        path: path,
        // name: path,
        query: query
        // params: query
    }),
        type = isSelf ? '_self' : '_blank';
    window.open(newpage.href, type);
}

function navigationPropsTo(path, params = {}, isSelf, isReplace) {
    let jumpType = isReplace ? 'replace' : 'resolve',
        newpage = this.$router[jumpType]({
            name: path,
            params: params
        }),
        type = isSelf ? '_self' : '_blank';
    window.open(newpage.href, type);
}


export {
    navigationTo, navigationPropsTo
}


// WEBPACK FOOTER //
// ./src/mixins/methods/navigation.js